/* istanbul ignore file */
import React from 'react';
import Promise from 'bluebird';
import PropTypes from 'prop-types';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { perfMarkerPropTypes } from '@bingads-webui/performance-marker';
import { AudienceCampaignCreationWizard } from '@bingads-webui-campaign-legacy/audience-campaign/loader';
import decimal from '@bingads-webui-component-legacy/humanize/decimal';
import PageContext from '@bingads-webui-static-legacy/page-context';
import { getEntityCreationStyle } from '../styles';
import { InjectWrapperWithHoC, withCreationHeader } from '../helper';
import VerticalLayout from '../template/steps-template.pug';
import HeaderTemplate from '../template/header-template.pug';

const $top = 10000;

function CampaignCreationAudienceShopping(props) {
  const {
    serverContext: {
      CurrentAccount: {
        CurrencyCode,
      },
      Permissions: {
        IsReadOnlyUser,
        IsEnabledForDynamicFeedCampaign,
      },
      CurrentAccountInActive,
    },
    perfMarker,
  } = props;
  return (
    <InjectWrapperWithHoC
      {...props}
      InjectViewFactory={() => Promise.resolve(AudienceCampaignCreationWizard)}
      InjectViewOption={{
        viewContext: {
          accountCurrencyCode: CurrencyCode,
          isReadOnlyUser: IsReadOnlyUser,
          CurrentAccountInActive,
        },
        audienceCampaignType: 'shopping',
        audienceCampaignSubType: 'audiencefeedbased',
        perfMarker,
        layout: VerticalLayout,
        headerTemplate: HeaderTemplate,
        initData: view => Promise.all(IsEnabledForDynamicFeedCampaign ?
          [view.getProductDataInit(), view.getFeedDataInit({ $top })] : [view.getProductDataInit()]),
        isForVNext: true,
        deps: {
          decimal,
          pageContext: PageContext,
        },
      }}
      styleScopeName="CampaignCreationAudienceShopping"
    />);
}

CampaignCreationAudienceShopping.propTypes = {
  serverContext: PropTypes.shape({
    CurrentAccount: PropTypes.shape({
      CurrencyCode: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  perfMarker: perfMarkerPropTypes.isRequired,
  decimal: PropTypes.shape({}).isRequired,
  PageContext: PropTypes.shape({}).isRequired,
};

export const StyledCampaignCreationAudienceShopping =
  withDefaultStyles(withCreationHeader(CampaignCreationAudienceShopping), getEntityCreationStyle);
